import apiService from './apiService';
import { API_ENDPOINTS } from '../config/api';

class ReviewService {
  // Értékelések lekérése egy adott szolgáltatóhoz
  async getReviewsForProvider(providerId, params = {}) {
    try {
      const queryParams = new URLSearchParams();
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      if (params.status) queryParams.append('status', params.status); // Pl. 'APPROVED'
      
      const response = await apiService.get(`${API_ENDPOINTS.REVIEWS.LIST}/provider/${providerId}?${queryParams.toString()}`);
      return response;
    } catch (error) {
      console.error('Értékelések lekérése szolgáltatóhoz hiba:', error);
      throw error;
    }
  }

  // Értékelés elküldése
  async submitReview(reviewData) {
    try {
      const response = await apiService.post(API_ENDPOINTS.REVIEWS.CREATE, reviewData);
      return response;
    } catch (error) {
      console.error('Értékelés elküldése hiba:', error);
      throw error;
    }
  }

  // Értékelés frissítése (ha engedélyezett)
  async updateReview(reviewId, reviewData) {
    try {
      const response = await apiService.put(API_ENDPOINTS.REVIEWS.DETAIL(reviewId), reviewData);
      return response;
    } catch (error) {
      console.error('Értékelés frissítése hiba:', error);
      throw error;
    }
  }

  // Értékelés törlése (ha engedélyezett)
  async deleteReview(reviewId) {
    try {
      const response = await apiService.delete(API_ENDPOINTS.REVIEWS.DETAIL(reviewId));
      return response;
    } catch (error) {
      console.error('Értékelés törlése hiba:', error);
      throw error;
    }
  }

  // Értékelés státuszának frissítése (admin/szolgáltató)
  async updateReviewStatus(reviewId, status, adminNotes = '') {
    try {
      const response = await apiService.put(API_ENDPOINTS.REVIEWS.STATUS(reviewId), { status, adminNotes });
      return response;
    } catch (error) {
      console.error('Értékelés státusz frissítése hiba:', error);
      throw error;
    }
  }

  // Válasz küldése értékelésre (szolgáltató)
  async replyToReview(reviewId, reply) {
    try {
      const response = await apiService.put(API_ENDPOINTS.REVIEWS.REPLY(reviewId), { reply });
      return response;
    } catch (error) {
      console.error('Értékelésre válasz hiba:', error);
      throw error;
    }
  }

  // Felhasználó saját értékeléseinek lekérése
  async getMyReviews(params = {}) {
    try {
      const queryParams = new URLSearchParams();
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      
      const response = await apiService.get(`${API_ENDPOINTS.REVIEWS.MY}?${queryParams.toString()}`);
      return response;
    } catch (error) {
      console.error('Saját értékelések lekérése hiba:', error);
      throw error;
    }
  }
}

export default new ReviewService();